export enum TypeDataPlannerMatrix {
    DISTANCE = "distance",
    DURATION = "duration"
}